import { render, staticRenderFns } from "./QuantityField.vue?vue&type=template&id=1081cfbb"
import script from "./QuantityField.vue?vue&type=script&lang=js"
export * from "./QuantityField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports